import { createUseStyles } from "react-jss";
import { colors } from "constants/colors";
import { breakpoints } from "constants/breakpoints";

const styles = createUseStyles((theme) => ({
  contentContainer: {
    border: "1px solid" + colors.lightGrey,
    borderRadius: "12px",
    boxShadow: `0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)`,
  },
  tierCard: {
    backgroundColor: colors.brightBlue,
    borderRadius: "12px 12px 0px 0px",
    padding: "24px",
    borderBottom: "1px solid" + colors.lightGrey,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "14px",
    },
  },
  tierTypeWrapper: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    height: "auto",
    marginBottom: "7px",
    "& h6": {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "30px",
      color: colors.lightBlack,
      margin: "0px",
    },
  },
  tierTypeIcon: {
    "& svg": {
      fill: theme.discounts.tierLogo.backgroundColor,
      "& rect": {
        stroke: theme.discounts.tierLogo.borderColor,
      },
      "& path": {
        stroke: theme.discounts.tierLogo.color,
      },
    },
  },
  tierTypeIconActive: {
    "& svg": {
      fill: theme.discounts.tierLogoActive.backgroundColor,
      "& rect": {
        stroke: theme.discounts.tierLogoActive.borderColor,
      },
      "& path": {
        stroke: theme.discounts.tierLogoActive.color,
      },
    },
  },
  progressBar: {
    height: "16px",
    borderRadius: "8px",
    backgroundColor: colors.lightGrey,
    marginBottom: "15px",
    "& .progress-bar": {
      borderRadius: "8px",
      backgroundColor: theme.discounts.progressBar.color,
    },
  },
  progressBarActive: {
    extend: "progressBar",
    "& .progress-bar": {
      backgroundColor: theme.discounts.progressBarActive.color,
    },
  },
  infoContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    [`@media (min-width: ${breakpoints.sm}px)`]: {
      "& div:first-of-type": {
        textAlign: "left",
      },
      "& div:last-of-type": {
        textAlign: "right",
      },
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column-reverse",
      gap: "16px",
    },
  },
  infoWrapper: {
    "& h6": {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "30px",
      color: colors.lightBlack,
      marginBottom: "4px",
    },
    "& span": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
    },
  },
  popoverStyle: {
    "& .popover-arrow": {
      display: "none !important",
    },
  },
  popoverDiv: {
    position: "absolute",
    alignItems: "center",
    backgroundColor: colors.white,
    padding: "6px",
    width: "240px",
    border: `1px solid ${colors.lightGrey}`,
    boxShadow:
      "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    borderRadius: 8,
    color: colors.grey,
    transform: "translateY(30%) translateX(12%)",
    right: "100%",
    "& span": {
      display: "block",
    },
  },
  popoverItem: {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
    fontWeight: "500",
    color: colors.grey,
    padding: "10px",
    cursor: "pointer",
    fontFamily: theme.fontFamily,
    "&:hover": {
      background: colors.brightBlue,
      borderRadius: "8px",
    },
    "& svg": {
      marginRight: "8px",
      "& path": {
        strokeWidth: 1.5,
      },
    },
  },
  dotsStyle: {
    marginLeft: "auto",
    cursor: "pointer",
    "&:hover": {
      "& path": {
        stroke: colors.grey,
      },
    },
    "&:focus": {
      "& path": {
        stroke: colors.grey,
      },
    },
  },
  dotsOpenStyle: {
    "& path": {
      stroke: colors.grey,
    },
  },
  tierUnavailableWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: "352px",
    margin: "0px auto",
    "& h6": {
      color: colors.lightBlack,
      marginBottom: "4px",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: "0px",
    },
  },
  retryBtn: {
    marginTop: "24px",
    alignItems: "center",
    padding: "8px 14px",
    "& svg": {
      marginRight: "3px",
    },
  },
}));

export default styles;
